import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { I18nService } from 'src/app/services/i18n.service';
import { NewsletterService } from 'src/app/services/newsletter.service';
import { NewsletterState } from 'src/app/models/newsletter';

// Lien reçu par e-mail après une inscription à la newsletter (double opt-in)
@Component({
    selector: 'app-newsletter-confirm',
    templateUrl: './newsletter-confirm.component.html',
    styleUrls: ['./newsletter-pages.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NewsletterConfirmComponent implements OnInit {

  loading = true;
  state: NewsletterState | null = null;
  error = '';

  private i18n = inject(I18nService);

  constructor(private route: ActivatedRoute, private newsletterService: NewsletterService) { }

  ngOnInit(): void {
    const token = this.route.snapshot.paramMap.get('token');
    if (!token) {
      this.loading = false;
      this.error = this.i18n.t('newsletter.confirmInvalid');
      return;
    }
    this.newsletterService.confirm(token).subscribe({
      next: state => {
        this.loading = false;
        this.state = state;
      },
      error: err => {
        this.loading = false;
        this.error = err || this.i18n.t('newsletter.confirmInvalid');
      }
    });
  }
}
